export function initializeDictionaries() {
    const emotions = [
      "sad", "tired", "lonely", "happy", "grateful", "calm", "stressed", "scared", "angry",
    ];
    const currentDict = {};
    const compareDict = {};
    emotions.forEach((emotion) => {
      currentDict[emotion] = 0;
      compareDict[emotion] = 0;
    });
    return { currentDict, compareDict };
  }
  
  export function initializeEmotionDict() {
    const emotions = [
      "sad", "tired", "lonely", "happy", "grateful", "calm", "stressed", "scared", "angry",
    ];
    const emotionDict = {};
    emotions.forEach((emotion) => {
      emotionDict[emotion] = {};
    });
    return emotionDict;
  }

  export function initializeActionDictionaries() {
    const actions = [
      "Move my body",
      "Smile big",
      "Stretch",
      "Be mindful. Be where my feet are",
      "Help Others",
      "Think of 3 things that I am grateful for",
      "Give someone a compliment",
      "Give someone a high five",
      "Write in my journal",
      "Create art",
      "Imagine positive things in the future",
      "Laugh at something funny",
      "Remember that difficult times pass",
      "Remind myself of two good things in my life",
      "Tell myself something nice",
      "Get some sun in my eyes",
      "Count to ten taking a deep breath each time",
      "Imagine a peaceful place",
      "Listen to music or read",
      "Politely move away from a distraction",
      "Squeeze my fist",
      "Use my growth mindset",
    ]
    const currentActionDict = {};
    const compareActionDict = {};
    actions.forEach((action) => {
      currentActionDict[action] = 0;
      compareActionDict[action] = 0;
    });
    currentActionDict["Other"] = 0;
    compareActionDict["Other"] = 0;
    return { currentActionDict, compareActionDict };
  }